import { render, staticRenderFns } from "./ShareToTwitter.vue?vue&type=template&id=f2896edc&"
import script from "./ShareToTwitter.vue?vue&type=script&lang=js&"
export * from "./ShareToTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports